import {getMediaUrl} from '@/shared/lib/getMediaUrl';

export const LOGIN_STEPS_CARD = [
  {
    image: getMediaUrl('landing/profile.webp'),
    title: 'Create your profile',
    description:
      'Share details about yourself and add stunning photos to showcase your personality',
  },
  {
    image: getMediaUrl('landing/discover.webp'),
    title: 'Discover people globally',
    description:
      'Swipe through profiles of verified users worldwide to find your perfect bump.',
  },
  {
    image: getMediaUrl('landing/translate.webp'),
    title: 'Connect beyond language',
    description:
      'Start meaningful conversations with auto-translation, removing all language barriers.',
  },
];
